<template>
  <!--  && informationMessage.message[$i18n.locale] !== '' の記載について
  メッセージの公開/非公開状態をisShowで制御しているが、公開状態であっても日本語または英語のメッセージ片方がブランクになる場合がある。
  そのため、メッセージがブランクの場合は、iアイコンが非表示となるようにしている。-->
  <div
    v-if="informationMessage.isShow && informationMessage.message[$i18n.locale] !== ''"
    :class="[
      screenLandScape === false ? 'video-information-section' : 'video-information-section-side',
    ]"
  >
    <button
      :class="[
        screenLandScape === false
          ? 'video-information-section__button'
          : 'video-information-section-side__button',
      ]"
      @click="enableInformation = !enableInformation"
    >
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 15C0 6.71652 6.71652 0 15 0C23.2835 0 30 6.71652 30 15C30 23.2835 23.2835 30 15 30C6.71652 30 0 23.2835 0 15Z"
          fill="black"
        />
        <path
          d="M15 0C6.71652 0 0 6.71652 0 15C0 23.2835 6.71652 30 15 30C23.2835 30 30 23.2835 30 15C30 6.71652 23.2835 0 15 0ZM15 27.4554C8.12277 27.4554 2.54464 21.8772 2.54464 15C2.54464 8.12277 8.12277 2.54464 15 2.54464C21.8772 2.54464 27.4554 8.12277 27.4554 15C27.4554 21.8772 21.8772 27.4554 15 27.4554Z"
          fill="#F2C94C"
        />
        <path
          d="M13.1108 9.5144V6.79297H16.8823V9.5144H13.1108ZM13.1323 22.7144V11.7858H16.8394V22.7144H13.1323Z"
          fill="#F2C94C"
        />
      </svg>
    </button>

    <p
      :class="{
        'video-information-section__message': !screenLandScape,
        'video-information-section__message--show': !screenLandScape && enableInformation,
        'video-information-section-side__message': screenLandScape,
        'video-information-section-side__message--show': screenLandScape && enableInformation,
      }"
      v-html="informationMessage.message[$i18n.locale]"
      @click="enableInformation = false"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { AlertMessage } from '@/store/stores/collectionModule/documents/GeneralTypes'

export type DataType = {
  enableInformation: boolean
}

/**
 * レース動画再生画面 動画プレーヤー インフォメーションセクション
 */
export default defineComponent({
  name: 'VideoInformationSection',
  data(): DataType {
    return {
      enableInformation: false,
    }
  },
  props: {
    /**
     * インフォメーションメッセージ
     */
    informationMessage: {
      type: Object as PropType<AlertMessage>,
      // required: true,
      default: {
        playerId: '',
        message: {
          ja: '',
          en: '',
        },
        isShow: false,
      } as AlertMessage,
    },
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
  },
  setup(props) {
    const screenLandScape = computed(() => props.screenOrientationType.indexOf('landscape') !== -1)
    return {
      screenLandScape,
    }
  },
})
</script>

<style lang="scss" scoped>
.video-information-section {
  &__button {
    position: absolute;
    top: 9px;
    right: 10px;
    width: 30px;

    svg {
      width: 30px;
      height: 30px;
    }
  }

  &__message {
    position: absolute;
    top: 51px;
    right: 9px;
    padding: 5px 8px;
    max-width: calc(100% - 18px);
    border-radius: 4px;
    color: #fff;
    @include fontSetTextMedium();

    letter-spacing: 0.04em;
    background: rgba(#000, 0.9);
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
    pointer-events: none;

    &--show {
      opacity: 1;
      pointer-events: auto;
      white-space: pre-line;
    }

    &::before {
      position: absolute;
      right: 10px;
      top: -6px;
      display: block;
      content: '';
      width: 12px;
      height: 12px;
      border: 6px solid transparent;
      border-top-color: rgba(#000, 0.9);
      border-right-color: rgba(#000, 0.9);
      transform: rotate(-45deg);
    }
  }
}

.video-information-section-side {
  &__button {
    position: absolute;
    top: 9px;
    right: 30px;
    width: 30px;

    svg {
      width: 30px;
      height: 30px;
    }
  }

  &__message {
    position: absolute;
    top: 51px;
    right: 30px;
    padding: 5px 8px;
    max-width: calc(100% - 18px);
    border-radius: 4px;
    color: #fff;
    @include fontSetTextMedium();

    letter-spacing: 0.04em;
    background: rgba(#000, 0.9);
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
    pointer-events: none;

    &--show {
      opacity: 1;
      pointer-events: auto;
    }

    &::before {
      position: absolute;
      right: 10px;
      top: -6px;
      display: block;
      content: '';
      width: 12px;
      height: 12px;
      border: 6px solid transparent;
      border-top-color: rgba(#000, 0.9);
      border-right-color: rgba(#000, 0.9);
      transform: rotate(-45deg);
    }
  }
}
</style>
